<nz-spin [nzSpinning]="isLoading" nzSize="large" [nzTip]="loadingMessage" style="min-height: 200px; padding: 10px">
  <div class="market-board-header">
    <h2>Market Management</h2>
    <button nz-button nzType="primary" (click)="showMarketModal()">
      <span nz-icon nzType="plus" nzTheme="outline"></span> Add Market
    </button>
  </div>

  <div class="market-board" *ngIf="boardColumns.length > 0">
    <div *ngFor="let column of boardColumns" class="market-column" cdkDropList #marketCardList="cdkDropList"
      [cdkDropListId]="column.id" [cdkDropListData]="column.markets" [cdkDropListConnectedTo]="connectedLists"
      (cdkDropListDropped)="onMarketDrop($event)">
      <h3 class="market-column-title">{{ column.title }}</h3>
      <div class="market-column-cards">
        <div *ngFor="let market of column.markets" class="market-card" cdkDrag>
          <div class="market-card-content" cdkDragHandle>
            <div class="market-card-header">
              <strong>{{ market.name }}</strong>
              <nz-tag [nzColor]="market.active ? 'green' : 'default'" class="market-card-tag">
                {{ market.active ? 'Active' : 'Inactive' }}
              </nz-tag>
            </div>
            <div class="market-card-meta">{{ market.provider }}</div>
            <div class="market-card-meta">Leads: {{ market.leadCount }} · {{ market.penetration }}% penetration</div>
            <div class="market-card-actions">
              <button nz-button nzType="link" nzSize="small"
                (click)="showMarketModal(market); $event.stopPropagation()">
                <span nz-icon nzType="edit" nzTheme="outline"></span> Edit
              </button>
              <button nz-button nzType="link" nzSize="small" (click)="addBlitz(market); $event.stopPropagation()">
                <span nz-icon nzType="calendar" nzTheme="outline"></span> Blitz ({{ market.blitzes?.length || 0 }})
              </button>
              <nz-switch [(ngModel)]="market.active" [nzChecked]="market.active" [nzUnCheckedValue]="false"
                [nzCheckedValue]="true" (ngModelChange)="updateMarketActive(market, $event)" nzSize="small"
                (click)="$event.stopPropagation()"></nz-switch>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="market-board market-board-empty" *ngIf="boardColumns.length === 0 && !isLoading">
    <p>No users or markets yet. Add a market to get started.</p>
  </div>

  <nz-modal [(nzVisible)]="isMarketModalVisible" [nzTitle]="editingMarket ? 'Edit Market' : 'Add Market'"
    (nzOnCancel)="handleMarketModalCancel()" (nzOnOk)="handleMarketModalOk()">
    <ng-container *nzModalContent>
      <form nz-form [formGroup]="marketForm">
        <nz-form-item>
          <nz-form-label [nzSpan]="6">Market Name</nz-form-label>
          <nz-form-control [nzSpan]="14">
            <input nz-input formControlName="name" placeholder="e.g., New York City" [readonly]="!!editingMarket" />
          </nz-form-control>
        </nz-form-item>

        <nz-form-item>
          <nz-form-label [nzSpan]="6">Provider</nz-form-label>
          <nz-form-control [nzSpan]="14" nzErrorTip="Please select a provider">
            <nz-select formControlName="provider">
              <nz-option *ngFor="let provider of providers.data" [nzValue]="provider.name" [nzLabel]="provider.name">
              </nz-option>
            </nz-select>
          </nz-form-control>
        </nz-form-item>

        <nz-form-item>
          <nz-form-label [nzSpan]="6">Lead Count</nz-form-label>
          <nz-form-control [nzSpan]="14" nzErrorTip="Please enter a valid number">
            <nz-input-number formControlName="leadCount" [nzMin]="0" style="width: 100%"></nz-input-number>
          </nz-form-control>
        </nz-form-item>

        <nz-form-item>
          <nz-form-label [nzSpan]="6">Penetration</nz-form-label>
          <nz-form-control [nzSpan]="14" nzErrorTip="Please enter a valid number">
            <nz-input-number formControlName="penetration" [nzMin]="0" style="width: 100%"></nz-input-number>
          </nz-form-control>
        </nz-form-item>

        <nz-form-item>
          <nz-form-label [nzSpan]="6">Offer</nz-form-label>
          <nz-form-control [nzSpan]="14">
            <input nz-input formControlName="offer" placeholder="e.g., Offer 1" />
          </nz-form-control>
        </nz-form-item>

        <nz-form-item>
          <nz-form-label [nzSpan]="6">Competition</nz-form-label>
          <nz-form-control [nzSpan]="14">
            <input nz-input formControlName="competition" placeholder="e.g., Competition 1" />
          </nz-form-control>
        </nz-form-item>
        <nz-form-item>
          <nz-form-label [nzSpan]="6">Active</nz-form-label>
          <nz-form-control [nzSpan]="14">
            <nz-switch formControlName="active" [nzUnCheckedValue]="false" [nzCheckedValue]="true"></nz-switch>
          </nz-form-control>
        </nz-form-item>
      </form>
    </ng-container>
  </nz-modal>

  <nz-modal [(nzVisible)]="isBlitzModalVisible" [nzTitle]="editingBlitz?.blitz ? 'Edit Blitz' : 'Add Blitz'"
    (nzOnCancel)="handleBlitzModalCancel()" (nzOnOk)="handleBlitzModalOk()">
    <ng-container *nzModalContent>
      <form nz-form [formGroup]="blitzForm">
        <nz-form-item>
          <nz-form-label [nzSpan]="6">Date Range</nz-form-label>
          <nz-form-control [nzSpan]="14" nzErrorTip="Please select dates">
            <nz-range-picker formControlName="dateRange" (ngModelChange)="onDateRangeChange($event)"></nz-range-picker>
          </nz-form-control>
        </nz-form-item>

        <!-- Hidden form controls for start and end dates -->
        <input type="hidden" formControlName="startDate">
        <input type="hidden" formControlName="endDate">

        <nz-form-item>
          <nz-form-label [nzSpan]="6">Rep Count</nz-form-label>
          <nz-form-control [nzSpan]="14" nzErrorTip="Please enter a valid number">
            <nz-input-number formControlName="repCount" [nzMin]="1" style="width: 100%"></nz-input-number>
          </nz-form-control>
        </nz-form-item>

        <nz-divider></nz-divider>
        <h4>Results</h4>

        <div formGroupName="results">
          <nz-form-item>
            <nz-form-label [nzSpan]="6">Contacted</nz-form-label>
            <nz-form-control [nzSpan]="14">
              <nz-input-number formControlName="contactedCount" [nzMin]="0" style="width: 100%"></nz-input-number>
            </nz-form-control>
          </nz-form-item>

          <nz-form-item>
            <nz-form-label [nzSpan]="6">Success</nz-form-label>
            <nz-form-control [nzSpan]="14">
              <nz-input-number formControlName="successCount" [nzMin]="0" style="width: 100%"></nz-input-number>
            </nz-form-control>
          </nz-form-item>

          <nz-form-item>
            <nz-form-label [nzSpan]="6">Notes</nz-form-label>
            <nz-form-control [nzSpan]="14">
              <textarea nz-input formControlName="notes" rows="4"></textarea>
            </nz-form-control>
          </nz-form-item>
        </div>
      </form>
    </ng-container>
  </nz-modal>
</nz-spin>